/** Public brand defaults use confirmed contact details; explicit VITE settings override them. */
import { placeholders } from './content'
import { unsetContactFields } from './contact-fields.mjs'

const env = import.meta.env

function pick(envValue: string | undefined, fallback: string) {
  const v = envValue?.trim()
  return v ? v : fallback
}

export const brand = {
  name: pick(env.VITE_BRAND_NAME, 'Ledgerline Procurement'),
  shortName: 'Ledgerline',
  domain: pick(env.VITE_BRAND_DOMAIN, 'ledgerlineprocurement.com'),
  callbackNumber: pick(env.VITE_CALLBACK_NUMBER, placeholders.callbackNumber),
  contactEmail: pick(env.VITE_CONTACT_EMAIL, placeholders.contactEmail),
  privacyEmail: pick(env.VITE_PRIVACY_EMAIL, placeholders.privacyEmail),
  mailingAddress: pick(env.VITE_MAILING_ADDRESS, placeholders.mailingAddress),
  legalEntity: pick(env.VITE_LEGAL_ENTITY, placeholders.legalEntity),
  apiBase: pick(env.VITE_API_BASE, '/api'),
} as const

/** Fields without explicit deployment overrides, for release configuration checks. */
export function usingPlaceholders(): string[] {
  return unsetContactFields(env)
}
